export default __webpack_public_path__ + "static/media/fiercely-independent-img2.1a2e8858.jpg";